const PanelContainer = {
  baseStyle: {
    p: "0px",
    w: "100%",
    maxW: "100%",
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
